/*******************************
 *  --scrollbar-width and --window-height CSS variables
 ******************************/

function calculateScrollbarWidth() {
  var scrollbarWidth = window.innerWidth - document.body.clientWidth
  document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px')
}
calculateScrollbarWidth()

function calculateWindowHeight() {
  document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px')
}
calculateWindowHeight()

// In case the initial scrollbar width has been calculated before the body was rendered,
// we need observe it and recalculate the scrollbar width when it's ready.
if (document.body.clientWidth === 0) {
  let observer = new ResizeObserver(([{ contentRect }]) => {
    if (contentRect.width > 0) {
      calculateScrollbarWidth()
      observer.disconnect()
    }
  })
  observer.observe(document.body)
}

window.addEventListener('resize', () => {
  requestAnimationFrame(() => {
    calculateScrollbarWidth()
    calculateWindowHeight()
  })
})
